'use client';

import type { LotteryOptionGoodsForm } from '../../types';
import styles from './OptionSelectableBar.module.scss';

export type OptionSelectableBarProps = {
  optionFormData?: LotteryOptionGoodsForm;
  totalCount: number;
  onGoBack: () => void;
  onSubmit: () => void;
};

function OptionSelectableBar({ optionFormData, totalCount, onGoBack, onSubmit }: OptionSelectableBarProps) {
  // 入力完了ボタンのボタン色を取得
  const getConfirmButtonColor = (): 'gray' | 'primary' => {
    if (!optionFormData) return 'gray';
    const remainingCount = Math.max(0, optionFormData.totalAcquiredCount - totalCount);
    return remainingCount > 0 ? 'gray' : 'primary';
  };

  // 入力完了ボタンを無効にするかどうかの判定
  const isConfirmButtonDisabled = (): boolean => {
    if (!optionFormData) return true;
    const remainingCount = Math.max(0, optionFormData.totalAcquiredCount - totalCount);
    return remainingCount > 0;
  };

  // 残りの選択が必要な数を取得
  const getRemainingCount = (): number => {
    if (!optionFormData) return 0;
    return Math.max(0, optionFormData.totalAcquiredCount - totalCount);
  };

  const confirmButtonColor = getConfirmButtonColor();
  const confirmButtonDisabled = isConfirmButtonDisabled();
  const remainingCount = getRemainingCount();

  return (
    <div className={styles.componentStyle}>
      <div className={styles.container}>
        <div className={styles.statusText}>
          <p className={styles.remainingText}>残り{remainingCount}個の選択が必要です</p>
          <p className={styles.selectedText}>{totalCount}個 選択済み</p>
        </div>
        <div className={styles.buttonWrapper}>
          <button type='button' className={styles.backButton} onClick={onGoBack}>
            戻る
          </button>
          <div className={styles.confirmButtonWrapper}>
            <button
              type='button'
              className={styles.confirmButton}
              onClick={onSubmit}
              color={confirmButtonColor}
              disabled={confirmButtonDisabled}
            >
              入力を完了する
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OptionSelectableBar;
